import LearnMoreComponent from "../Components/LearnMoreComponent";

const LearnMorePage = () => {

    return (
        <div>
            <LearnMoreComponent />
        </div>
    )
};

export default LearnMorePage;